








































import Vue from 'vue';
import FormField from './FormField.vue';
import ContainRelation from './ContainRelation.vue';
import customerVuex from '../../../vuex/common';
import { ScoreFilter } from '../../../models/CustomerFilter';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    FormField,
  },
  data() {
    return {
      hackId: 0,
    };
  },
  methods: {
    updateMinScore(value: number) {
      let v = this.customerFilter.score;
      if (this.customerFilter.scoreSum) {
        v = this.customerFilter.scoreSum;
      }
      v.minScore = value;
      this.updateScore(v);
    },
    updateMaxScore(value: number) {
      let v = this.customerFilter.score;
      if (this.customerFilter.scoreSum) {
        v = this.customerFilter.scoreSum;
      }
      v.maxScore = value;
      this.updateScore(v);
    },
    updateScore(v: ScoreFilter) {
      if (this.customerFilter.scoreSum) {
        this.$store.commit('UPDATE_CUSTOMER_FILTER', {
          key: 'scoreSum',
          value: v,
        });
      } else {
        this.$store.commit('UPDATE_CUSTOMER_FILTER', {
          key: 'score',
          value: v,
        });
      }
    },
    changeLabel(label: string) {
      this.$store.commit('SWITCH_FILTER_SCORE_LABEL', label);
      this.hackId++;
    },
    labelDisplay(): string {
      return this.customerState.customerFilter.scoreSum ? '累计积分' : '积分';
    },
  },
});
